/*
Copyright (c) 2021
*/

import constants from '../../constants';

const { REQUEST_CLIENTDASHBOARD_DATA, CLIENTDASHBOARD_DATA_RECEIVED } = constants.clientDashboardConstants;

export default {
    REQUEST_CLIENTDASHBOARD_DATA,
    CLIENTDASHBOARD_DATA_RECEIVED,

  requestclientDashboardData: payload => ({
    type: REQUEST_CLIENTDASHBOARD_DATA,
    payload
  }),
  clientDashboardDataReceived: () => ({
    type: CLIENTDASHBOARD_DATA_RECEIVED
  }),
};
